import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-calendar-custom-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
	query: ['date?'],
};
